/* Theme Toggle Button */
.themeToggleBtn {
  height: 32px;
  border-radius: 4px;
  background-color: var(--color-background-secondary-subtle);
  border: 1px solid var(--color-border-secondary-subtlest);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0;
  transition: all 0.2s ease;
}

.themeToggleBtn:hover {
  background-color: var(--color-background-neutral-subtle);
  border-color: var(--color-border-secondary-subtle);
}

.themeToggleBtn:active {
  background-color: var(--color-background-neutral-subtlest);
  border-color: var(--color-border-secondary-subtlest);
}

.themeToggleBtn:focus-visible {
  outline: 2px solid var(--color-border-focus);
  outline-offset: 2px;
}

/* Theme Toggle Button Content */
.themeToggleBtnContent {
  align-self: stretch;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  gap: 4px;
}

/* Theme Icon */
.themeIcon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: var(--color-foreground-secondary-medium);
}

/* Theme Label */
.themeLabel {
  font-family: 'Rubik', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: var(--color-foreground-neutral-bold);
  white-space: nowrap;
  display: none;
}

/* Show label on larger screens */
@media (min-width: 768px) {
  .themeLabel {
    display: inline;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .themeToggleBtn {
    height: 32px;
    width: 32px;
    padding: 0;
  }

  .themeToggleBtnContent {
    padding: 4px;
  }

  .themeLabel {
    display: none;
  }
}
